<p-messages [severity]="Severity">
    <ng-template pTemplate>
        <span class="flex-1">{{ Message }}</span>
        <a *ngIf="MessageLink" (click)="ViewDetailsClicked()">{{ MessageLink }}</a>
    </ng-template>
</p-messages>
